/* eslint-disable no-case-declarations */
import { UPDATE_ALGO_LIST_TOTAL_LTP_PERIOD } from '../../constants/ActionTypes';
import { TOTAL_LTP_PERIOD } from '../../constants/cookies';
import storage from '../../storage';
import { readBuffer, writeBuffer } from '../../utils';

function getTotalLtpPeriod() {
  const isTotalLtpHidden = storage.getItem('totalPnlHidden') || false;
  const sessionData = readBuffer(TOTAL_LTP_PERIOD) || 'ALL';

  if (isTotalLtpHidden) {
    writeBuffer(TOTAL_LTP_PERIOD, 'NONE');
    return 'NONE';
  }

  // session data conflict failsafe
  if (sessionData === 'NONE') {
    writeBuffer(TOTAL_LTP_PERIOD, 'ALL');
    return 'ALL';
  }

  return sessionData;
}

const algoListSavedConfig = (
  state = { totalLtpPeriod: getTotalLtpPeriod() },
  action
) => {
  switch (action.type) {
    case UPDATE_ALGO_LIST_TOTAL_LTP_PERIOD:
      writeBuffer(TOTAL_LTP_PERIOD, action.data);

      storage.setItems({
        totalPnlHidden: action.data === 'NONE' ? true : false,
      });
      return { ...state, totalLtpPeriod: action.data };
    default:
      return state;
  }
};

export default algoListSavedConfig;
